const Tag = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='40.236'
    height='37.119'
    viewBox='0 0 40.236 37.119'
    fill='#152a46'
    {...props}
  >
    <path
      id='tag'
      d='M35.52,15.586,20.467.533a1.986,1.986,0,0,0-.554-.41A1.619,1.619,0,0,0,19.236,0H1.723A1.691,1.691,0,0,0,.472.472,1.746,1.746,0,0,0,0,1.764V19.236a1.768,1.768,0,0,0,.123.7,1.7,1.7,0,0,0,.369.533L15.545,35.52a5.91,5.91,0,0,0,1.8,1.189,4.9,4.9,0,0,0,1.887.41,4.7,4.7,0,0,0,1.969-.41,6.29,6.29,0,0,0,1.723-1.189L35.52,22.928h0a5.1,5.1,0,0,0,0-7.342Zm-2.461,4.881L20.467,33.059a1.686,1.686,0,0,1-2.461,0L3.486,18.539V3.486H18.539l14.52,14.52a1.686,1.686,0,0,1,0,2.461ZM9.27,9.27a1.986,1.986,0,0,0-.41.554,1.619,1.619,0,0,0-.123.677,1.619,1.619,0,0,0,.123.677,1.986,1.986,0,0,0,.41.554,2.051,2.051,0,0,0,.533.39,1.546,1.546,0,0,0,.7.144,1.448,1.448,0,0,0,.656-.144,2.843,2.843,0,0,0,.574-.39,2.435,2.435,0,0,0,.369-.554,1.619,1.619,0,0,0,.123-.677,1.619,1.619,0,0,0-.123-.677,2.435,2.435,0,0,0-.369-.554,1.686,1.686,0,0,0-2.461,0ZM40.236,36.75'
    />
  </svg>
)

export default Tag
